export default "/_next/static/images/right_arrow-ca8531cdd399ec819bc73dbeb9e50ec5.svg";